import { AUTH_TOKEN_KEYS } from '../../constants/common';
import { getLocalItem } from '../../utils/config/localStorage';

const AUTH_STORAGE_POLL_MS = 50;
const AUTH_STORAGE_TIMEOUT_MS = 5000;

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/** Wait until login storage has settled (accessToken + userId). */
export const waitForAuthStorageReady = async () => {
  const deadline = Date.now() + AUTH_STORAGE_TIMEOUT_MS;

  while (Date.now() < deadline) {
    const accessToken = getLocalItem(AUTH_TOKEN_KEYS.ACCESS_TOKEN, null);
    const userId = getLocalItem(AUTH_TOKEN_KEYS.USER_ID, null);
    if (accessToken && userId) {
      return true;
    }
    await sleep(AUTH_STORAGE_POLL_MS);
  }

  return Boolean(getLocalItem(AUTH_TOKEN_KEYS.ACCESS_TOKEN, null));
};
